import { Admin_Dashboard_Daily_Present_Absent } from './admin-dashboard-daily-present-absent.model';
import { ApiErrorCode } from '../service-proxies';


export class Admin_Dashboard_Daily_Present_AbsentApiResponse implements IAdmin_Dashboard_Daily_Present_AbsentApiResponse {
    isSuccess!: boolean;
    responseData!: Admin_Dashboard_Daily_Present_Absent;
    errorCode!: ApiErrorCode;
    errorMessage!: string | undefined;
    errorTitle!: string | undefined;

    constructor(data?: IAdmin_Dashboard_Daily_Present_AbsentApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.responseData = _data["responseData"] ? Admin_Dashboard_Daily_Present_Absent.fromJS(_data["responseData"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorTitle = _data["errorTitle"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_Daily_Present_AbsentApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_Daily_Present_AbsentApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorTitle"] = this.errorTitle;
        return data; 
    }
}

export interface IAdmin_Dashboard_Daily_Present_AbsentApiResponse {
    isSuccess: boolean;
    responseData: Admin_Dashboard_Daily_Present_Absent;
    errorCode: ApiErrorCode;
    errorMessage: string | undefined;
    errorTitle: string | undefined;
}

